// extracted by mini-css-extract-plugin
export default {"patientManualPrescriptions":"PatientManualPrescriptions_patientManualPrescriptions__MG8YH"};